import React from "react";
import { HelpCircle, Lightbulb } from "lucide-react";

export default function ProblemConsultations() {
  return (
    <section className="bg-white py-16 md:py-24">
      <div className="max-w-7xl mx-auto px-3 sm:px-4 lg:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          {/* Left Column: Image */}
          <div className="relative rounded-[32px] overflow-hidden shadow-sm h-[400px] md:h-[500px]">
            <img
              src="/doctor_pointing.webp"
              alt="Frustrated doctor looking at x-ray"
              width="1200"
              height="800"
              loading="lazy"
              className="w-full h-full object-cover"
            />
          </div>

          {/* Right Column: Content */}
          <div>
            <h2 className="text-2xl sm:text-3xl font-bold text-slate-900 mb-6 tracking-tight leading-tight">
              Why Dental Case Acceptance Rates Stay Below 40%
            </h2>
            <p className="text-base text-slate-900 mb-10">
              Most dental patients struggle to visualize treatment outcomes from
              verbal descriptions alone — whether it's dental implants, veneers,
              or full-arch restoration.
            </p>

            {/* Cards Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Card 1: Question */}
              <div className="bg-white rounded-[24px] p-6 sm:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] ring-1 ring-slate-100 flex flex-col h-full">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-8 shadow-sm"
                  style={{
                    background:
                      "radial-gradient(circle at center, #3b82f6 0%, #0066ff 100%)",
                  }}
                >
                  <HelpCircle className="text-white w-6 h-6" />
                </div>

                <h3 className="text-xl font-bold text-slate-900 mb-6 leading-snug">
                  Even when patients trust their dentist, they still hesitate:
                </h3>

                <ul className="space-y-4 mt-auto">
                  <li className="flex items-start gap-3">
                    <div className="mt-1 flex-shrink-0 w-4 h-4 rounded-full bg-red-500 flex items-center justify-center text-white text-[10px] font-bold">
                      ?
                    </div>
                    <span className="text-slate-500 text-[15px] font-medium leading-tight">
                      "Will this really look good on me?"
                    </span>
                  </li>
                  <li className="flex items-start gap-3">
                    <div className="mt-1 flex-shrink-0 w-4 h-4 rounded-full bg-red-500 flex items-center justify-center text-white text-[10px] font-bold">
                      ?
                    </div>
                    <span className="text-slate-500 text-[15px] font-medium leading-tight">
                      "Is this worth a $30,000 investment?"
                    </span>
                  </li>
                </ul>
              </div>

              {/* Card 2: Solution */}
              <div className="bg-white rounded-[24px] p-6 sm:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)] ring-1 ring-slate-100 flex flex-col h-full">
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-8 shadow-sm"
                  style={{
                    background:
                      "radial-gradient(circle at center, #3b82f6 0%, #0066ff 100%)",
                  }}
                >
                  <Lightbulb className="text-white w-6 h-6" />
                </div>

                <h3 className="text-xl text-slate-900 mb-4 leading-snug">
                  <strong>
                    SmileReveal™ eliminates that hesitation with AI smile
                    simulation.
                  </strong>
                </h3>

                <p className="text-slate-400 text-[15px] leading-relaxed mt-auto">
                  When patients can clearly see their future smile using
                  photorealistic AI previews, uncertainty disappears — and case
                  acceptance climbs to 60%+.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
